import React from 'react';
import {
  Button,
  DarkModeIcon,
  LightModeIcon,
  Tooltip,
} from '@billda/design-system';
import { useThemeStore } from '../../stores/themeStore';

interface ThemeToggleProps {
  size?: 'small' | 'medium' | 'large';
}

/**
 * Simple theme toggle component for light/dark mode
 */
export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  size = 'medium',
}) => {
  const { mode, toggleMode } = useThemeStore();

  const handleToggle = () => {
    toggleMode();
  };

  const getIcon = () => {
    return mode === 'light' ? (
      <DarkModeIcon aria-hidden="true" className="size-5" />
    ) : (
      <LightModeIcon aria-hidden="true" className="size-5" />
    );
  };

  const getTooltip = () => {
    return `Switch to ${mode === 'light' ? 'dark' : 'light'} mode`;
  };

  const buttonSize =
    size === 'small' ? 'size-8' : size === 'medium' ? 'size-10' : 'size-12';

  return (
    <Tooltip content={getTooltip()}>
      <Button
        variant="ghost"
        size="icon"
        onClick={handleToggle}
        className={`${buttonSize} text-content-secondary transition-transform duration-150 hover:rotate-90 hover:bg-surface-raised`}
        data-testid="theme-toggle-button"
        aria-label={getTooltip()}
      >
        {getIcon()}
      </Button>
    </Tooltip>
  );
};
